import './_highlight-scopes.scss';
import { ParticlesScene } from '@/ts/utils/webgl/scenes/particles.scene';
import { sceneLoader } from '@/ts/utils/webgl';

//Init Highlight Scopes component and enable better accessibility features.

export default function HighlightScopes() {
    const $highlightedAreas = document.querySelectorAll('.highlight-scopes');

    if ($highlightedAreas) {
        $highlightedAreas.forEach(($highlighted: any, indexGen: number) => {
            const $buttons = Array.from($highlighted.querySelectorAll('button.show-details'));
            const $areas = $highlighted.querySelectorAll('.area');
            const $gradients = $highlighted.querySelectorAll('.gradient');
            const $tabsMobile = $highlighted.querySelectorAll('.tab');
            const $arrowRight = $highlighted.querySelector('.arrow-right') as HTMLElement;
            const $arrowLeft = $highlighted.querySelector('.arrow-left') as HTMLElement;
            let currentTab = null as any;
            let currentActiveId = null as any;
            const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
            let noCanvas = window.innerWidth < 992;
            let stopAnimation = false;

            if (!mediaQuery || mediaQuery.matches) {
                stopAnimation = true;
            }

            function bindUI() {
                if (stopAnimation) {
                    $highlighted.classList.add('no-animation');
                }

                if(window.innerWidth > 992){
                    let higherArea = 0;

                    $areas.forEach(($area: any) => {
                        if ($area.clientHeight > higherArea) {
                            higherArea = $area.clientHeight;
                        }
                    });

                    $highlighted.querySelector('.parts').style.height = higherArea + 'px';
                }

                if ($buttons) {
                    $buttons.forEach(($btn: any, index: number) => {
                        const btnId = $btn.getAttribute('id');
                        $btn.addEventListener('click', () => {
                            if (currentActiveId !== index + 1) {
                                $highlighted.classList.remove('ok');
                                if (currentActiveId && !stopAnimation) {
                                    sceneLoader.unload(`particles-${indexGen}-${currentActiveId.toString()}`).then(() => {
                                        $highlighted.classList.add('ok');
                                    });
                                } else {
                                    $highlighted.classList.add('ok');
                                }

                                setTimeout(
                                    () => {
                                        currentActiveId = index + 1;

                                        $buttons.forEach(($btn: any) => {
                                            $btn.classList.remove('selected');
                                            $btn.setAttribute('aria-selected', 'false');
                                            $btn.setAttribute('tabindex', '-1');
                                        });

                                        $btn.classList.add('selected');
                                        $btn.setAttribute('aria-selected', 'true');
                                        $btn.setAttribute('tabindex', '0');

                                        $areas.forEach(($area: any, index: number) => {
                                            const areaId = $area.getAttribute('data-id');
                                            if (btnId && areaId === btnId) {
                                                $area.classList.remove('d-none');
                                                if (!noCanvas && !stopAnimation) {
                                                    sceneLoader.load(`particles-${indexGen}-${(index + 1).toString()}`, new ParticlesScene($area.querySelector('.background-image')));
                                                    sceneLoader.render();
                                                }
                                            } else {
                                                $area.classList.add('d-none');
                                            }
                                        });

                                        let gradientIdx = getIndex(index);

                                        $gradients.forEach(($gradient: any, indexGradient: number) => {
                                            if (indexGradient === gradientIdx) {
                                                $gradient.classList.add('visible');
                                            } else {
                                                $gradient.classList.remove('visible');
                                            }
                                        });
                                    },
                                    currentActiveId && !noCanvas && !stopAnimation ? 0 : 0
                                );
                            }
                        });

                        if (btnId && btnId === 'part-1') {
                            ($btn as HTMLButtonElement).click();
                        }
                    });
                }

                if ($tabsMobile) {
                    $tabsMobile.forEach(($tab: any, index: number) => {
                        const tabId = $tab.getAttribute('mobile-tab-id');
                        const $btnLength = $buttons.length;
                        const $firstBtn = $highlighted.querySelector('button#part-1') as HTMLElement;
                        const $lastBtn = $highlighted.querySelector(`button#part-${$btnLength}`) as HTMLElement;

                        if ($firstBtn.classList.contains('selected')) {
                            $arrowLeft.classList.add('disabled');
                        } else {
                            $arrowLeft.classList.remove('disabled');
                        }

                        if ($lastBtn.classList.contains('selected')) {
                            $arrowRight.classList.add('disabled');
                        } else {
                            $arrowRight.classList.remove('disabled');
                        }

                        $tab.onclick = () => {
                            $tabsMobile.forEach(($tab: any) => {
                                $tab.classList.remove('selected');
                                $tab.setAttribute('aria-selected', 'false');
                            });

                            $tab.classList.add('selected');
                            $tab.setAttribute('aria-selected', 'true');

                            if ($buttons) {
                                $buttons.forEach(($btn: any) => {
                                    if (tabId && $btn.id.includes(tabId)) {
                                        $btn.classList.add('selected');
                                    } else {
                                        $btn.classList.remove('selected');
                                    }
                                });

                                if ($firstBtn.classList.contains('selected')) {
                                    $arrowLeft.classList.add('disabled');
                                } else {
                                    $arrowLeft.classList.remove('disabled');
                                }

                                if ($lastBtn.classList.contains('selected')) {
                                    $arrowRight.classList.add('disabled');
                                } else {
                                    $arrowRight.classList.remove('disabled');
                                }
                            }

                            let gradientIdx = getIndex(index);

                            $gradients.forEach(($gradient: any, indexGradient: number) => {
                                if (gradientIdx === indexGradient) {
                                    $gradient.classList.add('visible');
                                } else {
                                    $gradient.classList.remove('visible');
                                }
                            });

                            if ($areas) {
                                $areas.forEach(($area: any) => {
                                    const areaId = $area.getAttribute('data-id');
                                    if (tabId && areaId === tabId) {
                                        $area.classList.remove('d-none');
                                    } else {
                                        $area.classList.add('d-none');
                                    }
                                });
                            }
                        };

                        if (tabId && tabId === 'part-1') {
                            ($tab as HTMLButtonElement).click();
                        }
                    });
                }

                if (window.innerWidth < 992) {
                    const $selectedBtns = $highlighted.querySelectorAll('.show-details');
                    const $content = $highlighted.querySelector('.parts') as HTMLDivElement;

                    if ($selectedBtns.length) {
                        $selectedBtns.forEach(($btn: any) => {
                            $btn.setAttribute('tabindex', '-1');
                        });
                    }

                    $content.setAttribute('id', 'content-slides');
                }

                if ($arrowRight) {
                    $arrowRight.onclick = () => {
                        const selectedTab = $highlighted.querySelector('.tab.selected') as any;
                        const $tabs = $highlighted.querySelectorAll('.tab');
                        if (selectedTab) {
                            if (selectedTab?.nextElementSibling) {
                                selectedTab?.nextElementSibling?.click();
                            } else {
                                if ($tabs && $tabs[0]) {
                                    $tabs[0].click();
                                }
                            }
                        }
                    };
                }

                if ($arrowLeft) {
                    $arrowLeft.onclick = () => {
                        const selectedTab = $highlighted.querySelector('.tab.selected') as any;
                        const $tabs = $highlighted.querySelectorAll('.tab');
                        if (selectedTab) {
                            if (selectedTab?.previousElementSibling) {
                                selectedTab?.previousElementSibling?.click();
                            } else {
                                if ($tabs && $tabs[$tabs.length - 1]) {
                                    $tabs[$tabs.length - 1].click();
                                }
                            }
                        }
                    };
                }
            }

            function bindSwipe() {
                if (window.innerWidth < 992) {
                    let startX = 0;
                    let startY = 0;

                    $highlighted.addEventListener('touchstart', (e: any) => {
                        startX = e.touches[0].clientX;
                        startY = e.touches[0].clientY;
                    });

                    $highlighted.addEventListener('touchend', (e: any) => {
                        const endX = e.changedTouches[0].clientX;
                        const endY = e.changedTouches[0].clientY;
                        const diffX = startX - endX;
                        const diffY = startY - endY;

                        if (Math.abs(diffX) > Math.abs(diffY)) {
                            if (diffX > 0) {
                                $arrowRight?.click();
                            } else {
                                $arrowLeft?.click();
                            }
                        }
                    });
                }
            }

            function handleAccessibility() {
                $buttons.forEach(($btn: any, index: number) => {
                    $btn.addEventListener('keydown', function (event: any) {
                        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                            if (event.key === 'ArrowLeft') {
                                currentTab = currentTab === 0 ? $buttons.length - 1 : currentTab - 1;
                            } else {
                                currentTab = currentTab === $buttons.length - 1 ? 0 : currentTab + 1;
                            }

                            ($buttons[currentTab] as any).focus();
                        }
                    });

                    $btn.addEventListener('click', function () {
                        currentTab = index;
                    });
                });
            }

            function bindResize() {
                document.addEventListener('resize', () => {
                    if (window.innerWidth < 992) {
                        noCanvas = true;
                    } else {
                        noCanvas = false;
                    }
                });
            }

            function getIndex(index: number) {
                if (index === 0) {
                    return 0;
                } else if (index === 1) {
                    return 1;
                } else if (index === 2) {
                    return 2;
                } else if (index % 3 === 0) {
                    return 0;
                } else if ((index - 1) % 3 === 0) {
                    return 1;
                } else {
                    return 2;
                }
            }

            function init() {
                bindUI();
                bindResize();
                bindSwipe();
                handleAccessibility();
            }

            init();
        });
    }
}
